// Temporary rollout policy:
// administrators and super-administrators may access Command Centre.
// Planned future policy: super-administrator only.
export const COMMAND_CENTRE_ALLOWED_ROLES = new Set([
  'elite-core-operator',
  'elite-core-platform-administrator',
]);

export const normalizeRole = (role?: string | null): string =>
  String(role || '')
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, '-');

export function canAccessCommandCentre(role?: string | null, enabled = false): boolean {
  return enabled && COMMAND_CENTRE_ALLOWED_ROLES.has(normalizeRole(role));
}

export function isSuperAdministratorRole(role?: string | null): boolean {
  return normalizeRole(role) === 'super-administrator';
}

export const canEditEzee = (platformRole?: string | null, enabled = false): boolean => enabled && normalizeRole(platformRole) === 'elite-core-platform-administrator';
